// Force a matte mid-grey on a loaded <model-viewer> part so it reads like the
// POC stepcheck.html viewer (NEW Task#2). The GLB material is already grey
// (svc-09 mesh.py baseColorFactor [0.8,0.8,0.8]), but model-viewer's bright
// neutral image-based lighting washes a 0.8 albedo to near-white, whereas the
// POC three.js single-directional-light shades the same grey to mid-grey.
// Lowering the rendered albedo (not exposure/background) restores the POC tone
// for every part — existing GLBs included, no re-analysis needed.
//
// Tune GREY here if the operator wants it lighter/darker; the background
// (#fafafa) and exposure are intentionally left alone.

const GREY: readonly [number, number, number, number] = [0.5, 0.5, 0.52, 1];
const ROUGHNESS = 0.85;

interface PbrLike {
  setBaseColorFactor?: (rgba: readonly number[]) => void;
  setMetallicFactor?: (v: number) => void;
  setRoughnessFactor?: (v: number) => void;
}
interface MaterialLike {
  pbrMetallicRoughness?: PbrLike;
}
interface ModelViewerLike {
  model?: { materials?: MaterialLike[] } | null;
}

/** Apply the matte-grey override. Safe to call before the model is ready. */
export function applyMatteGrey(el: unknown): void {
  try {
    const materials = (el as ModelViewerLike | null | undefined)?.model?.materials;
    if (!materials || materials.length === 0) return;
    for (const m of materials) {
      const pbr = m.pbrMetallicRoughness;
      pbr?.setBaseColorFactor?.(GREY);
      pbr?.setMetallicFactor?.(0);
      pbr?.setRoughnessFactor?.(ROUGHNESS);
    }
  } catch {
    // model-viewer material API unavailable/changed — leave the GLB default.
  }
}
